import React from "react";
import { useScrollLock } from "../lib/scrollLock";
import styles from "./SubscriptionSuccessModal.module.css";

interface Props {
  visible: boolean;
  title?: string;
  message?: string;
  onClose: () => void;
}

export function SubscriptionSuccessModal({ visible, title, message, onClose }: Props) {
  useScrollLock(visible);

  if (!visible) return null;

  return (
    <div
      className={styles.overlay}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
      role="presentation"
    >
      <div
        className={styles.card}
        role="dialog"
        aria-modal="true"
        aria-labelledby="sub-success-title"
      >
        <div className={styles.animContainer}>
          <div className={styles.successCircle}>
            <svg
              width="32"
              height="32"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </div>
        </div>

        <h3 id="sub-success-title" className={styles.title}>
          {title || "Subscription Successful"}
        </h3>
        {message ? <p className={styles.message}>{message}</p> : null}

        <div className={styles.packageButton}>
          <span className={styles.packageName}>Unlimited Yours Music Access</span>
          <span className={styles.badge}>Premium</span>
        </div>

        <button
          type="button"
          className={styles.button}
          onClick={onClose}
          autoFocus
        >
          OK
        </button>
      </div>
    </div>
  );
}

export default SubscriptionSuccessModal;
